const PhoneIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22.361"
      height="23.001"
      viewBox="0 0 22.361 23.001"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_33"
            data-name="Rectangle 33"
            width="22.361"
            height="23.001"
            fill="#ff5e11"
          />
        </clipPath>
      </defs>
      <g
        id="Groupe_23"
        data-name="Groupe 23"
        transform="translate(-122.09 -498.5)"
      >
        <g
          id="Groupe_22"
          data-name="Groupe 22"
          transform="translate(122.09 498.5)"
        >
          <g
            id="Groupe_21"
            data-name="Groupe 21"
            transform="translate(0)"
            clipPath="url(#clipPath)"
          >
            <path
              id="Tracé_13"
              data-name="Tracé 13"
              d="M14.747,56.764a8.364,8.364,0,0,1-3.4-.826A20.5,20.5,0,0,1,4.679,50.68,20.472,20.472,0,0,1,.4,43.349c-.82-2.819-.385-5.065,1.261-6.495a3.479,3.479,0,0,1,2.7-.973,2.837,2.837,0,0,1,1.984,1.338l2.021,3.034a2.49,2.49,0,0,1-.44,3.247l-.788.685c-.15.13-.13.422-.086.645a7.5,7.5,0,0,0,3.753,4.316c.214.074.5.134.65,0l.788-.685a2.489,2.489,0,0,1,3.276.016h0l2.724,2.424a2.836,2.836,0,0,1,1.047,2.15,3.479,3.479,0,0,1-1.34,2.542,4.754,4.754,0,0,1-3.21,1.167M4.016,37.318a2.239,2.239,0,0,0-1.393.639c-2.643,2.3-.412,7.658,3.159,11.765S14.356,56.793,17,54.495a2.074,2.074,0,0,0,.838-1.446A1.41,1.41,0,0,0,17.28,52l-2.724-2.424a1.025,1.025,0,0,0-1.349-.006l-.788.685a2,2,0,0,1-2.084.274,8.754,8.754,0,0,1-4.711-5.419,2,2,0,0,1,.562-2.026l.788-.685a1.025,1.025,0,0,0,.181-1.337L5.135,38.027a1.411,1.411,0,0,0-.964-.7,1.158,1.158,0,0,0-.156-.01"
              transform="translate(0 -33.763)"
              fill="#ff5e11"
            />
            <path
              id="Tracé_14"
              data-name="Tracé 14"
              d="M188.024,13.592l-.052,0a.73.73,0,0,1-.677-.779,10.649,10.649,0,0,0-9.869-11.352.73.73,0,1,1,.1-1.457,12.11,12.11,0,0,1,11.224,12.911.73.73,0,0,1-.728.679"
              transform="translate(-166.421 0)"
              fill="#ff5e11"
            />
            <path
              id="Tracé_15"
              data-name="Tracé 15"
              d="M181.3,64.335l-.052,0a.73.73,0,0,1-.677-.779,7.476,7.476,0,0,0-6.928-7.969.73.73,0,1,1,.1-1.457,8.936,8.936,0,0,1,8.283,9.528.73.73,0,0,1-.728.679"
              transform="translate(-162.856 -50.964)"
              fill="#ff5e11"
            />
            <path
              id="Tracé_16"
              data-name="Tracé 16"
              d="M174.572,115.078l-.052,0a.73.73,0,0,1-.678-.779,4.3,4.3,0,0,0-3.986-4.586.73.73,0,0,1,.1-1.457A5.764,5.764,0,0,1,175.3,114.4a.73.73,0,0,1-.728.679"
              transform="translate(-159.293 -101.928)"
              fill="#ff5e11"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default PhoneIcon;
